import useLoadingStore from "stores/useLoadingStore";
import useToastStore, { ToastType } from "stores/useToastStore";
const useToastErrorMessage = () => {
  const { stopLoading } = useLoadingStore();

  const { activeToast, closeToast } = useToastStore();

  const closeToastErrorMessage = () => {
    closeToast();
  };

  const showToastWithLoadingReset = (
    message: string,
    timeout: number,
    type: ToastType
  ) => {
    stopLoading();
    activeToast({ message: message, timeout: timeout, type: type });
  };

  const showToastErrorMessage = (message: string, timeout: number) => {
    showToastWithLoadingReset(message, timeout, "error");
  };

  const showToastSuccessMessage = (message: string, timeout: number) => {
    showToastWithLoadingReset(message, timeout, "success");
  };

  const showToastInfoMessage = (message: string, timeout: number) => {
    showToastWithLoadingReset(message, timeout, "info");
  };

  const showToastWarningMessage = (message: string, timeout: number) => {
    showToastWithLoadingReset(message, timeout, "warning");
  };

  return {
    showToastErrorMessage,
    showToastSuccessMessage,
    showToastInfoMessage,
    showToastWarningMessage,
    closeToastErrorMessage,
  };
};

export default useToastErrorMessage;
